import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { formatPrice } from 'utils/numberFormatter';
import { RowItems } from '../../../../../models/TableProps';
import { TableCellWrapper } from 'components/quotation-editor/shared/TableCellWrapper';
import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import { QuoSumProdCustomItemsRow } from './QuoSumProdCustomItemsRow';
import { StyledTableCellWrapper } from '../QuotationSummaryProducts';
import { useMemo } from 'react';
import {
    QuotationSummaryProdTableItemWithType,
    QuotationSummaryProdTableItemType,
} from '../../../../../models/quotations/Quotation';

const StyledProductRow = styled(TableRow)(() => ({
    '&.custom-items': {
        td: {
            //borderBottom: 'none !important',
        },
    },
}));

const StyledImage = styled(Box)(() => ({
    width: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '100%',
    },
}));

const StyledTitle = styled(Box)(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
}));

export const QuotationSummaryProdTableRow: React.FC<
    RowItems<QuotationSummaryProdTableItemWithType>
> = (props) => {
    const { row } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // handling the shitty issue that the backend did not provide us net_unit_price for the custom items
    const netUnitPrice = useMemo((): number => {
        switch (row.type) {
            case QuotationSummaryProdTableItemType.PRODUCT:
                return row.net_unit_price;
            case QuotationSummaryProdTableItemType.CUSTOM_ITEM:
                // calculating the net unit price from the gross_price because I'm not sure if the net_price will change in the future
                return row.gross_price / row.quantity / (1 + row.tax / 100);
            default:
                return null;
        }
    }, [row]);

    const netPrice = useMemo((): number => {
        switch (row.type) {
            case QuotationSummaryProdTableItemType.PRODUCT:
                return row.net_price;
            // same
            case QuotationSummaryProdTableItemType.CUSTOM_ITEM:
                return row.gross_price / (1 + row.tax / 100);
            default:
                return null;
        }
    }, [row]);

    return (
        <>
            <StyledProductRow
                hover
                className={
                    row.custom_items && row.custom_items.length > 0
                        ? 'custom-items'
                        : ''
                }
            >
                <StyledTableCellWrapper type={'name'}>
                    <StyledTitle>
                        {!isMobile && (
                            <StyledImage>
                                {row.image && row.image != 'icon' && (
                                    <img src={row.image} alt={row.name} />
                                )}
                                {row.image && row.image == 'icon' && (
                                    <PostAddIcon />
                                )}
                            </StyledImage>
                        )}
                        {row.name}
                    </StyledTitle>
                </StyledTableCellWrapper>
                <TableCellWrapper style={{ maxWidth: '5%', width: '5%' }}>
                    {`${row.quantity} ${row.unit}`}
                </TableCellWrapper>
                <StyledTableCellWrapper>
                    {netUnitPrice && formatPrice(netUnitPrice) + '\u00A0Ft'}
                </StyledTableCellWrapper>
                <StyledTableCellWrapper>
                    {row.price_margin !== undefined
                        ? formatPrice(row.price_margin) + ' Ft'
                        : ''}
                </StyledTableCellWrapper>
                <StyledTableCellWrapper>
                    {netPrice && formatPrice(netPrice) + '\u00A0Ft'}
                </StyledTableCellWrapper>
                <StyledTableCellWrapper>
                    {row.tax}&nbsp;%
                </StyledTableCellWrapper>
                <StyledTableCellWrapper>
                    {formatPrice(row.gross_price)}&nbsp;Ft
                </StyledTableCellWrapper>
            </StyledProductRow>
            {row.custom_items && (
                <QuoSumProdCustomItemsRow custom_items={row.custom_items} />
            )}
        </>
    );
};
